module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cDc1Z"))).then(() => parcelRequire('d0iPb'));